import React, {FC} from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import rehypeRaw from "rehype-raw";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {coy} from "react-syntax-highlighter/dist/esm/styles/prism";
import {Box, Grid, IconButton, Typography} from "@mui/material";
import {GradientButton, GradientText} from "./GradientComponents";
import MediumSquare from "../icons/MediumSquare";
import ThumbsUp from "../icons/ThumbsUp";
import ThumbsDown from "../icons/ThumbsDown";


interface MarkdownContentProps {
    isGenerating?: boolean;
    text: string;
    noPadding?: boolean;
}

const MarkdownContent: FC<MarkdownContentProps> = ({
                                                       isGenerating = false,
                                                       noPadding = false,
                                                       text
                                                   }) => {
    return (
        <Box sx={{p: noPadding ? 0 : 1, width: '100%'}}>
            <ReactMarkdown
                remarkPlugins={[remarkGfm, remarkBreaks]}
                rehypePlugins={[rehypeRaw]}
                skipHtml={true}
                components={{
                    code({node, inline, className, children, ...props}) {
                        const match = /language-(\w+)/.exec(className || '')
                        const text = String(children).replace(/<span class="typing-cursor" \/>/, '');
                        return !inline && match ? (
                            <SyntaxHighlighter
                                {...props}
                                wrapLongLines={true}
                                children={text}
                                style={coy}
                                language={match[1]}
                                PreTag="div"
                            />
                        ) : (
                            <SyntaxHighlighter
                                {...props}
                                wrapLongLines={true}
                                children={text}
                                style={coy}
                                PreTag="div"
                            />
                            // <code {...props} className={className}>
                            //     {children}
                            // </code>
                        )
                    },
                    span: ({node, className, children, ...props}) => {
                        const match = /typing-cursor/.exec(className || '')
                        if (match) {
                            return (
                                <span {...props} className="typing-cursor"/>
                            );
                        }
                        return (
                            <span {...props} className={className}
                                  children={String(children)}></span>
                        );
                    },
                    p: ({node, className, children, ...props}) => {
                        const {...rest} = props;
                        return <p style={{margin: 0}} {...rest}>{children}</p>
                    }
                }}
            >
                {
                    isGenerating ? (`${text} <span class="typing-cursor" />`) : text
                }
            </ReactMarkdown>
        </Box>
    );
}

export default MarkdownContent;
